import React, { useEffect } from 'react';

export const useClickOutside = (
  ref: React.RefObject<HTMLElement>,
  onClickOutside?: (event: MouseEvent) => void,
  ignoreSelector?: string,
) => {
  useEffect(() => {
    if (!onClickOutside) {
      return;
    }

    const click = (event: MouseEvent) => {
      if (!ref.current || ref.current.contains(event.target as HTMLElement)) {
        return;
      }

      if (
        ignoreSelector &&
        (event.target as HTMLElement).closest(ignoreSelector)
      ) {
        return;
      }

      onClickOutside(event);
    };

    document.addEventListener('mousedown', click);
    return () => document.removeEventListener('mousedown', click);
  }, [onClickOutside, ref, ignoreSelector]);
};
